import { render, staticRenderFns } from "./MaterialInward.vue?vue&type=template&id=59d6898e"
import script from "./MaterialInward.vue?vue&type=script&lang=js"
export * from "./MaterialInward.vue?vue&type=script&lang=js"
import style0 from "./MaterialInward.vue?vue&type=style&index=0&id=59d6898e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports